var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("VMM")]),_c('vue-json-pretty',{attrs:{"data":_vm.access_token}}),_c('button',{on:{"click":_vm.requestToken}},[_vm._v("GET TOKEN")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }